import React, { useState } from 'react';
import { Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap'
import ReactGA from 'react-ga';
import "react-datepicker/dist/react-datepicker.css";

export default function HomePage() {
    const [modalShow, setModalShow] = useState(false);


    return (
        <>
            <section id="header" className="d-flex align-items-center">
                <div className="row text-white">
                    <div className="col-12 col-sm-5 ms-sm-5">
                        <h2>Bicycle Insurance</h2>
                        <p>Get yourself protected whilst you enjoy your ride - provide bicycle damage and theft coverage </p>
                    </div>
                </div>
            </section>
            <section id="body">
                <div className="container">
                    <div className="row shadow title mt-n5 position-relative justify-content-center">
                        <div className="col-4 col-sm-2 align-self-center text-end py-3">
                            <img src="../images/bicycle-icon.png" alt="Bicycle Insurance" width={120} />
                        </div>
                        <div className="col-8 col-sm-5">
                            <h2 className="m-5 text-white fw-bold">Bicycle Insurance</h2>
                        </div>
                    </div>
                    <div className="row content">
                        <div className="col-1"></div>
                        <div className="col-10 shadow bg-white rounded">
                            <div className="row text-primary">
                                <div className="col-12 mt-1 text-center">
                                    <h5 className="text-primary fw-bold my-3">WHY YOU NEED IT</h5>
                                    <p>
                                        Cycling is an increasingly popular hobby/recreational sport in Malaysia, no matter if it's for leisure/recreation, commuting to school or work or general fitness.                                   
					 </p>
                                    <p>
                                        The increased cases of bicycle being stolen, frequent collisions between motor vehicles and bikes, and replacement of accessories may cost thousands of ringgits to repair.
					 </p>
                                    <p>
                                        Bicycle insurance can help to meet your riding needs, cover your financial loss when your bike is stolen or damaged. 
                                    </p>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-12 mt-1 text-center">
                                    <h5 className="text-primary fw-bold mb-3">COVERAGE AND FEATURES AT A GLANCE</h5>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Fire damage due to external explosion, self-ignition or lightning resulting to fire
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Replacement for theft and burglary*
    					 <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        *Only applicable to bicycles less than 1 years old (calculated from the date of manufacture), bicycles more than 1 years old will be covered based on the market value                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                        </OverlayTrigger>

                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Replacement for crash damage resulting in total loss*
					     <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        *Only applicable to bicycles less than 1 years old (calculated from the date of manufacture), bicycles more than 1 years old will be covered based on the market value                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Coverage for accessories and specified add-on parts**
					     <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                       **Only if the accessories and parts are specified in the policy schedule and loss/damage occurred as a result of accident, fire or theft
					  </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary me-2"></i>
                                        Coverage is applicable for road bikes, mountain bikes and off-road bicycles of all make and model
                                    </p>
                                    
                                </div>
                            </div>
                               <div className="col-12 text-center">
                                            <p className="pdpa small">
                                                By clicking 'Get Quote' button, you have read and agreed to our <a target="_blank" href={process.env.MIX_INSTAPOL_DOMAIN + "/privacy-policy"}>Privacy Policy</a>
                                            </p>
                                        </div>
                        </div>
                        <div className="col-1"></div>
                    </div>
                    <div className="row footer text-center mt-n3">
                        <div className="col-12">
			  
                            <Button type="button" variant="success" className="shadow px-4" onClick={() => setModalShow(true)}>Get Quote</Button>
                            <PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} />
                        </div>
                        <div className="row d-flex d-sm-none mt-3">
                            <div className="col-12 text-center">
                                <small>* Terms and conditions apply.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pds text-white mt-5">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="my-4 fw-bold">Please refer to the policy contract for more information on the benefits provided.</p>
                            </div>
                        </div>
                        <div className="row pds-row my-5">
                            <div className="col-12 col-sm-2">
                                <a href="/pdf/PDS_ALL_RISKS_BICYCLE_ENG.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/pdf-icon.png" alt="PDS_ALL_RISKS_BICYCLE_ENG.pdf" className="img" width={100} />
                                    </div>
                                    Bicycle Product Disclosure Sheet
                                </a>
                            </div>
                            <div className="col-12 col-sm-2">
                                <a href="/pdf/BicycleProductPolicy.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/pdf-icon.png" alt="BicycleProductPolicy.pdf" className="img" width={100} />
                                    </div>
                                    Product Clauses &amp; Exclusions
                                </a>
                            </div>
                            
                        </div>
                    
                        <div className="row text-center justify-content-around">
                            <p className="col-8 fw-bold mt-2">
                                Underwritten by Allianz General Insurance Company (Malaysia) Berhad 200601015674 (735426-V)
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

function PromptConfirmation(props) {
    const [agreed, setAgreed] = useState(null);

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header>
                <Modal.Title>Confirmation</Modal.Title>
                 <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.onHide}></button>

            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 text-justify">
                        <div className="col-12">I, declare that:</div>
                        <div className="col-12 mt-4">
				<p>
                                I am not a bankrupty or currently undergoing any bankruptcy/insolvency proceedings,
                                or been convicted in any court of law or subject to legal proceeding in any country.
                            </p>
                        </div>
                        <div className="row text-center mt-4">
                            <div className="col-12">
                                <input type="radio" value="true" name="disclosure" onChange={() => setAgreed(true)} /> Agree
                                <input className="ms-4" type="radio" value="false" name="disclosure" onChange={() => setAgreed(false)} /> Disagree
                            </div>
                            {
                                (agreed === false) ?
                                    <div className="col-12 text-danger">Apologies, we are not able to proceed with your enrolment.</div>
                                    : ''
                            }
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className="form-group row text-end">
                    <div className="col-5">
                        <Button type="button" className="btn btn-secondary" onClick={props.onHide}>Cancel</Button>
                    </div>
                    <div className="col-7">
                        <Button type="submit" className="btn btn-success" href="/Bike" disabled={agreed === null || agreed === false ? 'disabled' : ''}>Get Quote</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
